import CardTypeEdit from './CardTypeEdit';
import CardTypesList from './CardTypesList';

const resource = {
  list: CardTypesList,
  edit: CardTypeEdit,
};

export default resource;
